<template>
  <div class="page-wrapper">
    <div class="container-fluid mt-2">
      <loading :active.sync="isLoading" :is-full-page="fullPage" loader="bars">
      </loading>

      <!-- snooze modal -->
      <ConfirmModal
        :msg="$t('snooze_text')"
        :show="showConfirm"
        :heading="$t('snooze_receiver')"
        :btnTxt="$t('snooze')"
        @close="showConfirm = false"
        @submit="snoozeOrder"
        is-yellow
      />

      <!-- Start Dispatch Modal -->
      <ConfirmModal
        :msg="$t('dispatch_text')"
        :show="showDispatchModal"
        :heading="$t('start_dispatch')"
        :btnTxt="$t('start')"
        @close="showDispatchModal = false"
        @submit="handleDispatch"
        is-yellow
      />

      <!-- Warning Can't Track Modal -->
      <ConfirmModal
        :msg="$t('oops_msg')"
        :show="showOopsModal"
        :heading="$t('oops_heading')"
        :btnTxt="$t('ok')"
        @close="showOopsModal = false"
        @submit="showOopsModal = false"
        is-yellow
        :showSecondaryBtn="false"
      />

      <!-- Success Modal -->
      <SuccessModal
        :show="showSuccessPopup"
        @close="closeSuccess"
        :msg="successMsg"
        :heading="successHeading"
      />

      <DeleteModal
        :show="deleteModal"
        @close="deleteModal = false"
        :name="$t('dispatch')"
        @submit="doDelete"
        :action="action"
        :msg="msg"
      />

      <dispatch-tracker
        :show="showTracker"
        v-if="showTracker"
        @close="showTracker = false"
        :trackingCode="trackingCode"
        @pageChange="pageChange"
        @deviceSelected="handleTracking"
      />

      <div class="row">
        <div class="col-md-6 col-sm-6 col-lg-4 pl-0">
          <div class="card px-4">
            <div class="icon-wrapper icon-1">
              <img src="../../assets/images/Bag.svg" />
            </div>
            <div class="text">
              <span class="two small"> {{ $t("user") }} </span>
              <span class="one"> {{ profile.fullname }} </span>
              <span class="two"
                >{{ $t("order-number") }}:
                {{ singleOrder.orderReference }}</span
              >
              <span class="two status text-capitalize">
                {{ $t("status") }}:
                <span :class="`circle d-inline ${singleOrder.status}`"></span>
                {{ translateStatus(singleOrder.status) }}</span
              >
            </div>
          </div>
        </div>

        <div
          class="col-md-6 col-sm-6 col-lg-4 pl-0"
          v-if="singleOrder.driverDetails && singleOrder.driverDetails.name"
        >
          <div class="card px-4">
            <div class="card">
              <div class="icon-wrapper icon-2">
                <img src="../../assets/images/icon _truck_.svg" />
              </div>
              <div class="text">
                <span class="two small"> {{ $t("driver") }} </span>
                <span class="one"> {{ singleOrder.driverDetails.name }} </span>
                <span class="two">
                  {{ $t("vehicle") }}:
                  {{ singleOrder.vehicleDetails.plateNumber }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 col-sm-6 px-0">
          <div class="card px-4">
            <div class="icon-wrapper icon-3">
              <img src="../../assets/images/ion_location-outline.svg" />
            </div>
            <div class="text">
              <span class="two small"> {{ $t("pickup") }}</span>
              <span class="two">
                {{ singleOrder.pickup[0].address }}
              </span>
              <span class="two">
                {{ $t("phone-number") }}: {{ singleOrder.pickup[0].phone }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="largecardWrapper"
        style="height: fit-content; margin-top: 1.5rem"
      >
        <div
          class="priceSummaryWrapper"
          style="
            height: auto;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          "
        >
          <div class="priceSummaryCard" style="height: 100%; padding: 1rem">
            <div class="priceSummaryCard-info top" style="margin-bottom: 2rem">
              <div>
                <img src="../../assets/images/icons8_price-tag.svg" />
                <span> {{ $t("payment-summary") }}</span>
              </div>
              <!-- <span> {{ formattedTotalPrice(singleOrder.total) }} </span> -->
            </div>

            <div class="priceSummaryCard-info-wrapper">
              <div class="priceSummaryCard-info">
                <span class="light-text"> {{ $t("item") }} </span>
                <span>{{
                  formattedTotalPrice(singleOrder.totalItemsPrice)
                }}</span>
              </div>

              <div
                class="priceSummaryCard-info"
                v-if="singleOrder.insurancePlan"
              >
                <span class="light-text">
                  {{ $t("Insurance Fee")
                  }}{{ singleOrder.insurancePlan.name }}</span
                >
                <span>
                  {{ formattedTotalPrice(singleOrder.insurancePlan.price) }}
                </span>
              </div>
            </div>

            <div class="priceSummaryCard-info total">
              <span style="font-size: 14px"> {{ $t("total") }} </span>
              <span style="font-weight: 700; font-size: 14px">
                {{ formattedTotalPrice(singleOrder.totalProductWorth || singleOrder.total) }}
              </span>
            </div>
          </div>
        </div>
        <div class="card p-4 d-block" style="height: fit-content">
          <p class="font-bold">Dispatch Status Progress</p>

          <div class="stepper-container-width">
            <DispatchStepperVertical :step="step" :labels="labels" />
          </div>
        </div>
      </div>

      <div class="row">
        <div
          class="itemDetailsCard col-12"
          style="padding: 1rem; overflow-x: auto"
        >
          <p
            style="
              font-size: 16px;
              font-weight: 600;
              color: rgba(64, 74, 87, 1);
            "
          >
            {{ $t("item-details") }}
          </p>

          <table id="order-listing" class="table display">
            <thead style="background-color: rgba(240, 244, 251, 0.6)">
              <tr>
                <th
                  :key="index"
                  v-for="(column, index) in receiverTableColumns"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(
                  { items, contact, trackingCode, status }, index
                ) in singleOrder.dropoffs"
              >
                <tr
                  :key="index"
                  class="user-row"
                  style="border-bottom: unset"
                  :class="{
                    'gray-bg': index % 2 !== 0,
                  }"
                >
                  <td>{{ contact.name }}</td>
                  <td>{{ contact.email }}</td>
                  <td>{{ contact.phoneNumber }}</td>
                  <td>{{ items.length }}</td>
                  <td>{{ contact.address }}</td>
                  <td>
                    <div class="d-flex align-items-center col-gap-1">
                      <span
                        :class="`circle d-inline ${status}`"
                      ></span>
                      {{ translateStatus(status) }}
                    </div>
                  </td>

                  <td>
                    <div class="d-flex align-items-center col-gap-1">
                      <span
                        class="cursor-pointer"
                        @click="toggleAccordion(index)"
                      >
                        <DropdownIcon
                          v-if="index === expandedIndex"
                          style="transform: rotate(180deg)"
                        />
                        <DropdownIcon v-else />
                      </span>
                      <div
                        class="d-flex align-items-center col-gap-1"
                        v-if="
                          status !== 'completed' &&
                          status !== 'cancelled'
                        "
                      >
                        <!-- <button class="btn btn-primary w-100">
                          {{ $t("start-dispatch") }}
                        </button> -->
                        <span
                          v-if="status === 'new'"
                          @click="openDispatch(trackingCode)"
                          class="cursor-pointer"
                        >
                          <start-dispatch-icon />
                        </span>

                        <span
                          v-if="
                            status === 'in_progress' ||
                            status === 'new'
                          "
                          @click="handleDangerBtn(trackingCode)"
                          class="cursor-pointer"
                        >
                          <end-dispatch-icon />
                        </span>
                      </div>
                      <!-- <span class="cursor-pointer" @click="showConfirm = true">
                        <SnoozeIcon />
                      </span> -->
                      <span
                        class="cursor-pointer"
                        @click="openTracker(trackingCode)"
                        v-if="
                          status !== 'new' &&
                          status !== 'cancelled'
                        "
                      >
                        <PreviewIcon />
                      </span>
                    </div>
                  </td>
                </tr>
                <transition name="slide-fade" :key="'accordion-' + index">
                  <tr v-if="expandedIndex === index">
                    <td colspan="6" class="px-0 pt-0">
                      <table class="nested-table w-100">
                        <thead class="data-table-bg">
                          <tr>
                            <th
                              :key="index"
                              v-for="(column, index) in tableColumns"
                              style="cursor: pointer; text-align: left"
                            >
                              {{ column[0] }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in items"
                            :key="item.name + item.deliveryDate"
                          >
                            <!-- <td>{{ contact.name }}</td>
                            <td>{{ contact.email }}</td>
                            <td>{{ contact.phoneNumber }}</td>
                            <td>{{ contact.address }}</td> -->

                            <td>{{ formatDate(item.deliveryDate) }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.weight }}</td>
                            <td>{{ item.quantity }}</td>
                            <td>{{ item.logisticsType }}</td>
                            <td>{{ formattedTotalPrice(item.price) }}</td>
                            <td>{{ item.description }}</td>
                            <td
                              v-if="
                                item.dataLoggerSettings &&
                                item.dataLoggerSettings.minTemperature
                              "
                            >
                              {{ item.dataLoggerSettings.minTemperature }}
                            </td>
                            <td
                              v-if="
                                item.dataLoggerSettings &&
                                item.dataLoggerSettings.maxTemperature
                              "
                            >
                              {{ item.dataLoggerSettings.maxTemperature }}
                            </td>
                            <td
                              v-if="
                                item.dataLoggerSettings &&
                                item.dataLoggerSettings.minHumidity
                              "
                            >
                              {{ item.dataLoggerSettings.minHumidity }}
                            </td>
                            <td
                              v-if="
                                item.dataLoggerSettings &&
                                item.dataLoggerSettings.maxHumidity
                              "
                            >
                              {{ item.dataLoggerSettings.maxHumidity }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </transition>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewIcon from "../../components/Iconsvg/PreviewIcon.vue";
// import SnoozeIcon from "../../components/Iconsvg/SnoozeIcon.vue";
import DropdownIcon from "../../components/Iconsvg/DropdownIcon.vue";
import ConfirmModal from "../Modals/ConfirmModal.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import DeleteModal from "../Modals/DeleteModal.vue";
import DispatchTracker from "../Modals/DispatchTracker.vue";
import moment from "moment";
import StartDispatchIcon from "../../components/Iconsvg/StartDispatchIcon.vue";
import EndDispatchIcon from "../../components/Iconsvg/EndDispatchIcon.vue";
// import DispatchStepper from "../../components/DispatchStepper.vue";
import DispatchStepperVertical from "../../components/DispatchStepperVertical.vue";
import { currenciesFormat } from "../../utils/constants";

export default {
  name: "DispatchOrder",

  components: {
    DropdownIcon,
    // SnoozeIcon,
    PreviewIcon,
    ConfirmModal,
    SuccessModal,
    Loading,
    DeleteModal,
    DispatchTracker,
    StartDispatchIcon,
    EndDispatchIcon,
    // DispatchStepper,
    DispatchStepperVertical,
  },
  computed: {
    ...mapGetters(["singleOrder", "profile"]),
    tableColumns() {
      return [
        [this.$t("Date & Time"), "date"],
        [this.$t("Name"), "name"],
        [this.$t("Wgt"), "weight"],
        [this.$t("Qty"), "quantity"],
        [this.$t("Logistics"), "logistics"],
        [this.$t("price"), "price"],
        [this.$t("description"), "description"],
        ["Min Temp", "minTemp"],
        ["Max Temp", "maxTemp"],
        ["Min Humd", "minHumd"],
        ["Max Humd", "maxHumd"],
        // [this.$t("action"), "column2"],
      ];
    },
    receiverTableColumns() {
      return [
        [this.$t("reciever_name"), "column1"],
        [this.$t("email"), "column2"],
        [this.$t("phone_num"), "column3"],
        ["No of Items", "column4"],
        [this.$t("address"), "column5"],
        ["Status", "column6"],
        [this.$t("actions"), "column7"],
      ];
    },
    dangerBtnTxt() {
      let btnText = "";
      if (this.singleOrder.status === "new") {
        btnText = this.$t("cancel_order");
      } else if (this.singleOrder.status === "in_progress") {
        btnText = this.$t("end_order");
      }
      return btnText;
    },
    msg() {
      let msg = "";
      if (this.singleOrder.status === "new") {
        msg = this.$t("cancel_text");
      } else if (this.singleOrder.status === "in_progress") {
        msg = this.$t("end_text");
      }
      return msg;
    },
    action() {
      let action = "";
      if (this.singleOrder.status === "new") {
        action = "cancel";
      } else if (this.singleOrder.status === "in_progress") {
        action = "end";
      }
      return action;
    },
    successMsg() {
      let msg = "";
      if (this.dispatchAction === "start") {
        msg = this.$t("dispatch_started");
      } else if (this.dispatchAction === "cancel") {
        msg = this.$t("dispatch_order_cancelled");
      } else if (this.dispatchAction === "end") {
        msg = this.$t("dispatch_order_ended");
      }
      return msg;
    },
    successHeading() {
      let heading = "";
      if (this.dispatchAction === "start") {
        heading = this.$t("dispatch-started");
      } else if (this.dispatchAction === "cancel") {
        heading = this.$t("order-cancelled");
      } else if (this.dispatchAction === "end") {
        heading = this.$t("order-ended");
      }
      return heading;
    },
  },
  mounted() {
    if (!this.$route.params.id) {
      return this.$router.push({ name: "Dispatch" });
    } else {
      this.getSingleOrder(this.$route.params.id)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$router.push({ name: "Dispatch" });
        });
    }
    console.log(this.step, 'step mounted')
  },
  data() {
    return {
      showConfirm: false,
      showDispatchModal: false,
      showSuccessPopup: false,
      isLoading: true,
      fullPage: true,
      expandedIndex: null,
      dispatchAction: "",
      deleteModal: false,
      showTracker: false,
      trackingCode: "",
      showOopsModal: false,
      labels: ["Order picked up", "Order on the way", "Order arrived"],
      step: null,
    };
  },
  methods: {
    ...mapActions([
      "getSingleOrder",
      "startOrder",
      "snoozeReceiver",
      "cancelOrder",
      "endOrder",
      "trackOrder",
      "trackOrderHistory",
      "trackOrderHistoryChart",
      "trackOrderHistoryMapPoints",
    ]),

    snoozeOrder() {
      this.showConfirm = false;
    },
    handleDispatch() {
      if (this.dispatchAction === "start") {
        this.isLoading = true;
        this.startOrder({
          id: this.singleOrder.id,
          trackingCode: this.trackingCode,
        })
          .then(() => {
            this.showDispatchModal = false;
            this.isLoading = false;
            this.showSuccess();
            this.getSingleOrder(this.$route.params.id);
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    openDispatch(trackingCode) {
      this.showDispatchModal = true;
      this.dispatchAction = "start";
      this.trackingCode = trackingCode;
    },
    showSuccess() {
      this.showSuccessPopup = true;
    },
    formattedTotalPrice(amount) {
      if (!this.singleOrder.currency) return amount;
      return new Intl.NumberFormat(
        currenciesFormat[this.singleOrder.currency],
        {
          style: "currency",
          currency: this.singleOrder.currency,
        }
      ).format(amount);
    },
    toggleAccordion(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
    handleDangerBtn(trackingCode) {
      if (this.singleOrder.status === "new") {
        this.deleteModal = true;
        this.dispatchAction = "cancel";
      } else if (this.singleOrder.status === "in_progress") {
        this.deleteModal = true;
        this.dispatchAction = "end";
        this.trackingCode = trackingCode;
      }
    },
    doDelete() {
      if (this.dispatchAction === "cancel") {
        this.isLoading = true;
        this.cancelOrder(this.singleOrder.id)
          .then(() => {
            this.deleteModal = false;
            this.getSingleOrder(this.$route.params.id).then(() => {
              this.isLoading = false;
            });
            this.showSuccess();
          })
          .catch(() => {
            this.deleteModal = false;
            this.isLoading = false;
          });
      } else if (this.dispatchAction === "end") {
        this.isLoading = true;
        this.endOrder({
          id: this.singleOrder.id,
          trackingCode: this.trackingCode,
        })
          .then(() => {
            this.deleteModal = false;
            this.getSingleOrder(this.$route.params.id).then(() => {
              this.isLoading = false;
            });
            this.showSuccess();
          })
          .catch(() => {
            this.deleteModal = false;
            this.isLoading = false;
          });
      }
    },
    closeSuccess() {
      this.showSuccessPopup = false;
      this.dispatchAction = "";
      this.trackingCode = "";
    },
    handleTrackOrder(trackingCode) {
      this.isLoading = true;
      this.trackOrder({ id: this.$route.params.id, trackingCode })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleTrackOrderHistory(trackingCode, params) {
      this.isLoading = true;
      this.trackOrderHistory({
        id: this.$route.params.id,
        trackingCode,
        params,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleTrackOrderHistoryChart(trackingCode, params) {
      this.isLoading = true;
      this.trackOrderHistoryChart({
        id: this.$route.params.id,
        trackingCode,
        params,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleTrackHistoryMapPoints(trackingCode, params) {
      this.isLoading = true;
      this.trackOrderHistoryMapPoints({
        id: this.$route.params.id,
        trackingCode,
        params,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    openTracker(trackingCode) {
      if (this.singleOrder.status === "new") {
        this.showOopsModal = true;
        return;
      }
      this.showTracker = true;
      this.trackingCode = trackingCode;

      this.handleTrackOrder(trackingCode);
    },
    pageChange(params) {
      this.isLoading = true;
      this.params = params;
      this.handleTrackOrderHistory(this.trackingCode, params);
    },
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY HH:mmA") : "-";
    },
    translateStatus(status) {
      if (status === "new") {
        status = this.$t("new_new");
      } else if (status === "in_progress") {
        status = this.$t("in_progress");
      } else if (status === "completed") {
        status = this.$t("completed");
      } else if (status === "cancelled") {
        status = this.$t("cancelled");
      }
      return status;
    },
    handleTracking(device) {
      this.isLoading = true;
      const commonParams = {
        id: this.$route.params.id,
        trackingCode: this.trackingCode,
        dataLogger: device.id,
      };
      const params = {
        limit: 10,
        page: 1,
        ...commonParams,
      };
      this.handleTrackOrderHistory(this.trackingCode, params);
      this.handleTrackOrderHistoryChart(this.trackingCode, commonParams);
      this.handleTrackHistoryMapPoints(this.trackingCode, commonParams);
    },
  },
  watch: {
    singleOrder: {
      handler: function (val) {
        switch (val.status) {
          case "in_progress":
            this.step = 2;
            break;
          case "completed":
            this.step = 3;
            break;
          default:
            this.step = null;
            break;
        }
      },
      immediate: true,
      deep: true,
    },
  }
};
</script>

<style scoped>
.cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.5rem;
}

.card {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 100%;
  height: 130px;
}

.icon-wrapper {
  height: 60px;
  width: 60.9px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
}

.icon-1 {
  background-color: rgba(222, 234, 242, 0.4);
}

.icon-2 {
  background-color: rgba(143, 205, 159, 0.15);
}

.icon-3 {
  background-color: rgba(243, 201, 99, 0.15);
}

.text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.text > .one {
  font-weight: 800;
  font-size: 22px;
}

.text > .two {
  color: rgba(134, 147, 165, 1);
  font-size: 14px;
  font-weight: 400;
}

.text > .two.small {
  font-size: 12px;
  opacity: 70%;
}

.text > .two.status {
  display: flex;
  align-items: center;
}

.circle {
  margin-left: 4px;
  margin-right: 6px;
  height: 10px;
  width: 10px;
  border-radius: 100%;
  background-color: rgba(228, 169, 122, 1);
}

.largecardWrapper {
  position: relative;
  display: grid;
  grid-template-columns: 7fr 3fr;
  gap: 1rem;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
  margin-bottom: 2rem;
}

.itemDetailsCard,
.priceSummaryCard {
  background-color: #fff;
  border-radius: 16px;
}

.priceSummaryCard-info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-bottom: 1px solid rgba(227, 232, 239, 1);
  font-weight: 500;
  font-size: 14px;
  padding-bottom: 1rem;
}

.priceSummaryCard-info.top > div {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 16px;
  font-weight: 600;
  line-height: 20.8px;
}

.priceSummaryCard-info.top > span {
  font-size: 16px;
  font-weight: 600;
  color: rgba(64, 74, 87, 1);
}

.priceSummaryCard-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.light-text {
  color: rgba(134, 147, 165, 1);
}

.total {
  margin-top: 1rem;
}

.startDispatchBtn {
  width: 100%;
  height: 44px;
  border-radius: 16px;
  border: none;
  padding: 12px, 30px, 12px, 30px;
  background-color: rgba(33, 62, 122, 1);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: rgba(247, 248, 249, 1);
}

@media (max-width: 1024px) {
  .largecardWrapper {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }
}

@media (max-width: 768px) {
  .priceSummaryWrapper {
    width: 350px !important;
  }
  .flex-direction {
    flex-direction: column;
    column-gap: 1rem;
  }
}

.flex-direction {
  flex-direction: row;
  column-gap: 1rem;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-20px);
}

.new {
  background-color: #e4a97a;
}

.completed {
  background-color: #28a84a;
}

.in_progress {
  background-color: #f3c963;
}

.cancelled {
  background-color: #dc3030;
}

.row-gap {
  row-gap: 1rem;
}
</style>

<i18n>
  {
    "en": {
      "user": "User",
      "order-number": "Order number",
      "status": "Status",
      "driver": "Driver",
      "vehicle": "Vehicle",
      "pickup": "Pickup",
      "phone-number": "Phone no",
      "insurance-type": "Insurance Type",
      "item-details": "Item Details",
      "payment-summary": "Payment Summary",
      "item": "Item",
      "estimated-task": "Estimated Tax",
      "delivery-fee": "Delivery Fee",
      "total": "Total",
      "start-dispatch": "Start Dispatch",
      "product": "Product",
      "weight": "Weight",
      "price": "Price",
      "quantity": "Quantity",
      "description": "Description",
      "action": "Action"
    },
    "es": {
      "user": "Usuario",
      "order-number": "Número de orden",
    "status": "Estado",
    "driver": "Conductor",
    "vehicle": "Vehículo",
    "pickup": "Recogida",
    "phone-number": "Número de teléfono",
    "insurance-type": "Tipo de seguro",
    "item-details": "Detalles del artículo",
    "payment-summary": "Resumen del pago",
    "item": "Artículo",
    "estimated-task": "Tarea estimada",
    "delivery-fee": "Costo de envío",
    "total": "Total",
    "start-dispatch": "Iniciar despacho",
    "product": "Producto",
    "weight": "Peso",
    "price": "Precio",
    "quantity": "Cantidad",
    "description": "Descripción",
    "action": "Acción"
    },
    "fr": {
      "user": "Utilisateur",
    "order-number": "Numéro de commande",
    "status": "Statut",
    "driver": "Chauffeur",
    "vehicle": "Véhicule",
    "pickup": "Ramassage",
    "phone-number": "Numéro de téléphone",
    "insurance-type": "Type d'assurance",
    "item-details": "Détails de l'article",
    "payment-summary": "Résumé du paiement",
    "item": "Article",
    "estimated-task": "Tâche estimée",
    "delivery-fee": "Frais de livraison",
    "total": "Total",
    "start-dispatch": "Commencer la distribution",
    "product": "Produit",
    "weight": "Poids",
    "price": "Prix",
    "quantity": "Quantité",
    "description": "Description",
    "action": "Action"
    },
    "sw": {
      "user": "Mtumiaji",
    "order-number": "Nambari ya agizo",
    "status": "Hali",
    "driver": "Dereva",
    "vehicle": "Gari",
    "pickup": "Chukua",
    "phone-number": "Nambari ya simu",
    "insurance-type": "Aina ya bima",
    "item-details": "Maelezo ya kipengee",
    "payment-summary": "Muhtasari wa malipo",
    "item": "Kipengee",
    "estimated-task": "Kazi iliyokadiriwa",
    "delivery-fee": "Ada ya utoaji",
    "total": "Jumla",
    "start-dispatch": "Anza usambazaji",
    "product": "Bidhaa",
    "weight": "Uzito",
    "price": "Bei",
    "quantity": "Kiasi",
    "description": "Maelezo",
    "action": "Kitendo"
    }
  }
  </i18n>
